import React, { useEffect } from 'react';
import {
  Box,
  Col,
  Image,
  Row,
  Text,
  ListGroup,
} from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';
import { connect } from 'react-redux';
import translations from '../../lang';
import CoversationExplorerListItem from './ConversationExplorerListItem';
import { requestRecentConversations } from '../../actions/ConversationActions';

const StyledConversationExplorer = styled.div`
  padding-top: ${props => props.theme.spacing.medium};
  padding-bottom: ${props => props.theme.spacing.medium};
  padding-left: ${props => props.theme.spacing.large};
  padding-right: ${props => props.theme.spacing.large};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledConversationResultsContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  margin-top: 25px;
  overflow: auto;
`;

const StyledConversationResultContainerWrapper = styled.div`
  position: relative;
  flex: 1 1 0%;
  overflow: hidden;
`;

const ConversationExplorer = ({ conversation, requestRecentConversations }) => {
  useEffect(() => {
    requestRecentConversations();
  }, [requestRecentConversations]);

  return (
    <React.Fragment>
      <StyledConversationExplorer>
        <StyledConversationResultContainerWrapper>
          <StyledConversationResultsContainer data-test="result-container">
            {conversation.data && conversation.data.length !== 0 ? (
              <ListGroup
                direction="column"
                halign="left"
                items={conversation.data.map((item, index) => (
                  <CoversationExplorerListItem item={item} />
                ))}
                reverse={false}
                size="small"
              />
            ) : (
              <Row
                halign="center"
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Col span={5}>
                  <Box style={{ maxWidth: '150px', margin: '0 auto' }}>
                    <Image
                      alt="audience"
                      aspectratio="unset"
                      src="https://cdn.helixa.ai/images/workspace/audience.svg"
                      title="audience"
                    />
                  </Box>
                  <Box pY="large">
                    <Text align="center">
                      {
                        translations['en-US'].QUERY_BUILDER
                          .emptyConversationExplorer
                      }
                    </Text>
                  </Box>
                </Col>
              </Row>
            )}
          </StyledConversationResultsContainer>
        </StyledConversationResultContainerWrapper>
      </StyledConversationExplorer>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  requestRecentConversations,
};

const mapStateToProps = state => ({
  conversation: state.conversation,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationExplorer);
